import { useState } from 'react';
import { Eye, LogOut } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import { fmtDateTime } from '@/lib/format';

/**
 * شريطُ «عرضٌ بعين العضو» (0122): ثابتٌ أعلى كل صفحة ما دام العرضُ قائماً — على من، للقراءة فقط، وإلى متى، وخروجٌ يعيد جلسةَ المدير.
 * الكتابةُ ممنوعةٌ في الخادم (VIEWAS-001) وتُردّ في العميل قبله برسالةٍ واحدة.
 */
export function ViewAsBanner() {
  const { viewAs, exitViewAs } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!viewAs) return null;
  return (
    <div className="sandbox-banner view-as-banner" role="status">
      <Eye size={16} aria-hidden />
      <span className="grow">
        {`تعرض شاشاتِ ${viewAs.memberName} — للقراءة فقط. ينتهي تلقائياً ${fmtDateTime(viewAs.until)}.`}
      </span>
      <button type="button" className="sandbox-banner__back" disabled={busy} onClick={() => { setBusy(true); void exitViewAs().finally(() => setBusy(false)); }}>
        <LogOut size={15} aria-hidden /> خروج
      </button>
    </div>
  );
}
